import * as React from 'react';
function AddButton({ prefixCls, editable, locale, style, onClick }, ref) {
    if (!editable || editable.showAdd === false) {
        return null;
    }
    return (<button ref={ref} type="button" className={`${prefixCls}-nav-add`} style={style} aria-label={(locale === null || locale === void 0 ? void 0 : locale.addAriaLabel) || 'Add tab'} onClick={event => {
            onClick && onClick();
            editable.onEdit('add', {
                event
            });
        }}>
            {editable.addIcon || '+'}
        </button>);
}
export default React.forwardRef(AddButton);
